module.exports = __webpack_public_path__ + "img/lines.6cbce653.svg";